<template>
  <BaseModal
      :id="'static-update'"
      :title="title"
      :size="'lg'"
      :message="message"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>

        <template v-slot:content >
            <form @submit.prevent="formSubmit()">
            <div class="discharges-header mt-3">
                <div  class="d-flex form-discharges shadow p-3 mt-3 mb-3 bg-body rounded">
                    <div class="p-0  form-discharges__bed">
                        <div class="formdynamic__item__field" id="multiselect__schedule">
                            <multiselect v-model="selected_beds"  :options="beds" :multiple="true" :close-on-select="false" :clear-on-select="false" :taggable="true" :preserve-search="true" placeholder="Select bed code(s)" label="bed_code" track-by="bed_id" :preselect-first="false">
                                <template slot="selection" slot-scope="{ values }"><span class="multiselect__single" v-if="values.length" >{{ values.length }} bed code{{ values.length > 1  ? 's' : ''}}  selected</span></template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="p-0  form-discharges__minutes">
                        <div class="formdynamic__item__field">
                            <input  
                                placeholder="minutes"
                                type="number" 
                                v-model="minutes"
                            />
                        </div>
                    </div>
                    <div class="modal__buttons text-center text-md-left text-lg-center" style="margin-top: 0px;">
                        <button
                            @click="addDischarge()"
                            class="modal__buttons__item"
                            v-html="`Add`"
                            style="width:5rem;"
                            type="button"
                        />
                    </div>
                </div>
                <div>
                    <button type="button" class="modal__buttons__item" style="width: 7rem;" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="deleteDischarges()"/>
                </div>
            </div>

            <div class="row mb-0 mt-4 no-gutters" v-show="beds.length">
                <div class="col-md-12" style="margin-top:10px; ">
                    <v-card >
                        <DinamicTable
                        :ref="'dinamicTableBeds'"
                        :headers="table_headers"
                        :items="display_discharged_beds"
                        :search="search"
                        :checkable="true"
                        :link="'/building-room/'"
                        :selectable_columns="false"             
                        name="schedule_rooms_table"
                        size="26"
                        />
                    </v-card>
                </div>
            </div>
            <CentralLiteButtons :save_text="'Save Changes'"/>
            </form>
        </template>
    </BaseModal>
</template>

<script>

import Resources    from    './resources'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralLiteButtons   from    '@/components/CentralLiteButtons'
import Multiselect  from    "vue-multiselect"
import DinamicTable   from '@/components/DinamicTable'
import { emitDischargesForDashboard } from '../../../plugins/socket'

export default {
  name: "FormModalBeds",
  props: [
    "title",
    "parent_rest_api",
    "rest_api",
    "notyf",
    "array_options",
    "parent_id",
    "daily_assignment",
    "breadcrumb",
    "from_daily_assignment",
    "current_associate",
    "previous_date"
  ],

    components:{
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
        DinamicTable,
        Multiselect,
    },

    data(){
        return{
            table_headers: Resources.bed_table_headers,
            search: '',
            single_object: [],
            selected_beds: [],
            minutes: '',
            beds: [],
            discharged_beds: [],
            message: "If you would like to add discharges to beds, you can enter the minutes required. If you do not specify a number of minutes, the system will automatically save the discharge with the default minutes set for this assignment."

        }
    },

    methods: {
        addDischarge()
        {
            if(!this.minutes || this.minutes <= 0)
            {
                if(!this.daily_assignment.minutes || this.daily_assignment.minutes <= 0)
                {
                    this.notyfMesg('Enter the minutes, the daily assignment has no default discharge minutes ', 'error')
                    return;
                }
            }
            if(this.selected_beds.length)
            {
                this.selected_beds.forEach(selected_bed => 
                {
                    const obj = 
                    {
                        id: `local-${this.discharged_beds.length + 1}`,
                        is_new: true,
                        is_deleted: false,
                        bed_id: selected_bed.bed_id,
                        bed_code: selected_bed.bed_code,
                        room: selected_bed.room,
                        minutes:  (this.minutes) ? this.minutes : this.daily_assignment.minutes,
                        default_minutes:  (this.minutes) ? false : true,
                        created_at: this.getDateTimeFormat(this.previous_date, 'MM/DD/Y hh:mm a'),
                        created_at_original: this.getCurrentDateTime(this.previous_date),
                        checked: false,
                        associate: `${this.current_associate.last_name}, ${this.current_associate.first_name}`
                    }

                    this.discharged_beds.unshift(obj)

                });

                this.selected_beds = []
                this.minutes =       ''
            }
            else
            {
                this.notyfMesg('Select bed code(s)', 'error')
            }
        },

        deleteDischarges()
        {
            this.discharged_beds.forEach(discharged_bed => 
            {
                if(discharged_bed.checked)
                {
                    discharged_bed.is_deleted = true
                }
                
            });
        },

        formSubmit()
        {
            let discharges = this.discharged_beds.filter(discharge => discharge.is_new && !discharge.is_deleted || !discharge.is_new && discharge.is_deleted)

            this.single_object = {
                beds: discharges,
                supervisor_view: true,
                from_daily_assignment: this.from_daily_assignment
            }

            this.form_submit_update(this.parent_id, undefined, undefined, [{property: 'date', value: this.convertObjectDateToStringDate(this.previous_date)}])

            emitDischargesForDashboard(this.get_user().facility_id)
        },

        async initialSetup()
        {
            const http_object = {
                daily_assignment_id: this.daily_assignment.decrypted_id,
                supervisor_view: true,
            }
            
            let url = `${this.parent_rest_api}/beds/all`

            if(this.previous_date)
            {
                url += `?date=${this.convertObjectDateToStringDate(this.previous_date)}`
            }

            const response = await this.post(`${url}`, http_object)


            if(response.status)
            {
                this.beds = response.data.beds || []
                this.discharged_beds = response.data.discharged_beds || []
            }
            else
            {
                this.error_handling(response)
            }
        }
    },

    computed: 
    {

        selected()
        {
            return this.discharged_beds.filter(item => item.checked).length
        },

        display_discharged_beds()
        {
            return this.discharged_beds.filter(item => !item.is_deleted)
        }
    },

  

  mounted() 
  {
    
  },
};
</script>